import numeral from 'numeral';

export function getItemByNid(nid, collection) {
	if(nid < 0) return null;

	if(!collection || !collection.data || collection.data.length < 1 ) {
		return null;
	}

	for (let i = 0; i < collection.data.length; i++) {
		/* if(getValue(collection.data[i].Nid,'int') === getValue(nid,'int')) {
			retVal = collection.data[i];
			break;
		}*/

		if(collection.data[i].Nid === nid) {
			return collection.data[i];
		}
	}

	return null;
}

export function getValue(value, type) {
	let retVal;

	switch(type) {
		case 'int':
			retVal = parseInt(value, 10);
			break;

		case 'float':
			if(!value) {
				retVal = 0;
				break;
			}

			let floatTypeValue = value;
			if(typeof value == 'string' && value.indexOf(',') != -1) {
				let tmpArr = value.split(',');
				floatTypeValue = tmpArr.join('.');
			}
			retVal = parseFloat(floatTypeValue);
			break;

		case 'string':
			retVal = value.toString();
			break;

		case 'mmToMeters':
			retVal = parseFloat(value, 10) / 1000;
			break;

		case 'cmToMeters':
			retVal = parseFloat(value, 10) / 100;
			break;

		case 'secToH':
			retVal = value / 60 / 60;
			break;

		case 'gToKg':
			retVal = value / 1000;
			break;

		case 'cToE':
			retVal = value / 100;
			break;

		case 'wToKwh':
			retVal = value / 1000;
			break;

		default:
			retVal = parseInt(value, 10);

	}
	return retVal;
}

export function formatDecimalsW(value) {
  let retVal = value.toString() + ' W';
  if(value > 9999) {
    retVal = (numeral(value / 1000).format('0.0')).toString() + ' kW';
  } else if(value > 99) {
    retVal = (numeral(value).format('0')).toString() + ' W';
  }
  return retVal;
}

export function formatDecimalsWperArea(value) {
  let retVal = value.toString() + ' W/m²';
  if(value > 9999) {
    retVal = (numeral(value / 1000).format('0.0')).toString() + ' kW/m²';
  } else if(value > 99) {
    retVal = (numeral(value).format('0')).toString() + ' W/m²';
  }
  return retVal;
}

export function formatDecimalsWperLength(value) {
  let retVal = value.toString() + ' W/m';
  if(value > 9999) {
    retVal = (numeral(value / 1000).format('0.0')).toString() + ' kW/m';
  } else if(value > 99) {
    retVal = (numeral(value).format('0')).toString() + ' W/m';
  }
  return retVal;
}
